import React, { Component } from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Switch from "react-switch";
import { withStyles } from '@material-ui/styles'
import FiltroSearch from './FiltroSearch'
import OrdenLista from './OrdenLista'
import Chip from '@material-ui/core/Chip'
import Box from '@material-ui/core/Box'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import MainFiltros from './MainFiltros'
import { errorGetter } from '../common/backend/ApiErrorMessage'
import _ from 'lodash'
import { formatNumber } from '../common/Utilities'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as actions from './redux/actions'
import { REQUIRED_FIELD_MESSAGE } from '../common/PaginatedListController'
import clsx from 'clsx';
import ButtonComponent from 'common/button/Button.component';
import TuneIcon from '@material-ui/icons/Tune';
import { BUSINESS_UNIT, BUSINESS_UNIT_TABS } from './Constants';

const searchPlaceHolder = {
  businessUnit: 'Buscar por marca, modelo, versión, dominio, características...',
  savingPlan: 'Buscar por marca, modelo, versión, cuotas, financiación y características...',
}

const useStyles = () => ({
  switchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  swithLeyend: {
    paddingRight: '.5rem'
  },
})

export class MostrarResultados extends React.Component {
  render() {
    const { cantidad, error, requiredFieldsMissing, rightAlign, pendingTotalResults } = this.props
    const errorMessage = errorGetter(error)

    if (pendingTotalResults || cantidad == null) {
        return <div style={{ marginRight: '1rem' }} className="spinner-border spinner-border-sm" role="status">
          <span className="sr-only">Loading...</span>
        </div>
    }

    return (
      <div className={clsx("px-2 align-self-center mostrar-resultados", {"border-right": !rightAlign, "right-align": rightAlign})}>
        <p className="m-0">
          Se { cantidad > 1 ? `encontraron ` : `encontró `}
          <span className="cantidad">{formatNumber.separator(cantidad || 0)}</span>
          <span className="resultados">{ cantidad > 1 ? ` resultados` : ` resultado`}.</span>
        </p>
        {error && <p className="error-message">Error: {errorMessage}</p>}
        {requiredFieldsMissing?.length > 0 && (
          <p className="error-message">
            {REQUIRED_FIELD_MESSAGE + ': ' + requiredFieldsMissing.join(', ')}
          </p>
        )}
      </div>
    )
  }
}

export const NotFound = props => {
  const { items } = props
  return items?.length ? (
    <div className="px-2 align-self-center border-right d-none-mobile d-none-tablet">
      <p className="m-0 error-message">
        No se encontró resultados de las palabras: <b>{items.join(', ')}</b>
      </p>
    </div>
  ) : (
    ''
  )
}

class MostrarFiltros extends React.PureComponent {
  handleDelete = name => {
    this.props.onChangeFiltros({ name, value: undefined })
  }

  searchByCarLot = id => {
    let arrAux = this.props.carlots
    let item = arrAux.filter(e => e.id === id)
    return item.length === 0 ? 'No existe' : item[0].name
  }

  searchByBranchOffice = id => {
    for(const i in this.props.carlots) {
      const element = this.props.carlots[i]
      for(const j in element.Branch_offices) {
        const item = element.Branch_offices[j]
        if(item.id === id){
          return item.name
        }
      }
    }
  }

  render() {
    const { chipData } = this.props
    return (
      <div className="pl-1 min-height-32">
        <Box display="flex" justifyContent="flex-start">
          {chipData.map(data => {
            return (
              <Chip
                key={data.key}
                label={
                  data.key === 'venta_directa'
                    ? 'Venta Directa'
                    : data.key === 'venta_convencional'
                    ? 'Venta Convencional'
                    : data.key === 'car_lot_id'
                    ? `${this.searchByCarLot(data.label)}`
                    : data.key === 'branch_office_id'
                    ? `${this.searchByBranchOffice(data.label)}`
                    : data.key==='best_price'
                    ? 'Mejor precio'
                    : data.key === 'pea'
                    ? `${data.label === 'true' ? 'Con PEA':'Sin PEA'}`
                    : data.label
                }
                onClick={_.noop}
                onDelete={() => this.handleDelete(data.key)}
                className="ml-1 mr-1"
              />
            )
          }).filter(chip => chip.key !== 'stockDisponible')}
        </Box>
      </div>
    )
  }
}

class NavVendedor extends Component {
  static propTypes = {}

  constructor(props){
    super(props)
    this.state ={
      open: false,
      stockDisponible: this.props.filters.stockDisponible !== 'false'
    }
  }

  handleClick = () => {
    this.setState({open: !this.state.open});
  };

  handleClickAway = () => {
    this.setState({open:false});
  };

  closeFiltros = () => {
    window.$('#mainfiltros').collapse('hide')
    if (typeof this.props.onFiltersClose === 'function') {
      this.props.onFiltersClose()
    }
  }

  createChipData = filters => {
    return Object.entries(filters)
      .filter(
        ([key, value]) =>
          !!value &&
          key !== 'page' &&
          key !== 'per_page' &&
          key !== 'keyword' &&
          key !== 'sort' &&
          key !== 'tipo' &&
          key !== 'fields' &&
          key !== 'dinamicPagination' &&
          key !== 'leadId'
      )
      .map(([key, label]) => ({
        key,
        label: label === true ? key.replace('_', ' ').toUpperCase() : label
      }))
  }
  // Funciones de cambio de vista comentadas y no eliminadas ya que en el futuro seran utilizadas en un refactor.
  //Tambien se comenta el import de history

  // changeViewToGrilla = event => {
  //   history.push({
  //     search: history.location.search,
  //     hash: '#grilla',
  //     state: history.location.state
  //   })
  // }

  // changeViewToFila = event => {
  //   history.push({
  //     search: history.location.search,
  //     hash: '#fila',
  //     state: history.location.state
  //   })
  // }

  handleStockDisponible = (stockDisponible) => {
    this.props.onChangeFiltros({ name: 'stockDisponible', value: stockDisponible })
    this.setState({stockDisponible})
  }

  render() {
    const { classes } = this.props;
    const { stockDisponible } = this.state;

    const isSavingPlanTab = () => parseInt(this.props.tipo) === BUSINESS_UNIT_TABS.find(bu => bu.label === BUSINESS_UNIT.PlanAhorro).index

    const getPlaceHolder = () => isSavingPlanTab() ? searchPlaceHolder.savingPlan : searchPlaceHolder.businessUnit

    return (
      <div className="vista-vendedor-nav-vendedor">
        <AppBar position="static" color="inherit" elevation={0}>
          <Toolbar className="row toolbar">
            <div className="filtro-search">
              <FiltroSearch
                onChangeSearch={this.props.onChangeSearch}
                keywords={this.props.filters.keyword}
                placeHolder={getPlaceHolder()}
                className=""
                loadOptionsEndPoint={'catalogs'}
                noPadding={true}
              />
            </div>
              <div className=" busqueda-avanzada">
                <ClickAwayListener onClickAway={this.closeFiltros}>
                  <div className="accordion px-0" id="accordionExample" style={{ position: 'relative' }}>
                    <ButtonComponent
                      classNameProps="btn-sort"
                      label="filtrar"
                      variant="contained"
                      iconPosition="start"
                      icon={TuneIcon}
                      data-toggle="collapse"
                      data-target="#mainfiltros"
                      onClick={this.props.onFiltersClick}
                    />
                    <div
                      id="mainfiltros"
                      className="collapse main-filtros-container"
                      >
                      <div className="main-filtros">
                        <MainFiltros
                          filters={this.props.filters}
                          counters={this.props.counters}
                          onChangeFiltros={this.props.onChangeFiltros}
                          tipoCeroUsado={this.props.filters.tipo}
                          isPending={this.props.isPending}
                          />
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              </div>
            <div className='orden-lista'>
              <OrdenLista
                onChangeFiltros={this.props.onChangeFiltros}
                sort={this.props.filters.sort}
                className="col p-0"
                tipo={this.props.filters.tipo}
              />
            </div>
          </Toolbar>
          <div className="row d-flex justify-content-between mx-0">
            <div className="col-auto d-none-mobile">
              <div className="d-flex py-3" >
                <NotFound items={this.props.itemsNotFound} />
                <MostrarFiltros
                  carlots={this.props.common.user?.license?.company?.Car_lots}
                  chipData={this.createChipData(this.props.filters)}
                  onChangeFiltros={this.props.onChangeFiltros}
                />
              </div>
            </div>
            {
              (!isSavingPlanTab()) &&
              <div className={`switch-stock-disponible  ${classes.switchContainer}`} >
                <span className={`${classes.swithLeyend} label-switch`}>Ver stock disponible</span>
                <Switch
                  checked={stockDisponible}
                  onChange={(e) => this.handleStockDisponible(e)}
                  inputProps={{ 'aria-label': 'controlled' }}
                  onColor="#B689FF"
                  offColor="#B9B9B9"
                  disabled={this.props.pending}
                  onHandleColor="#6A2FD1"
                  offHandleColor="#EFEFEF"
                  handleDiameter={25}
                  uncheckedIcon={true}
                  checkedIcon={true}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  label="start"
                  className="react-switch"
                  id="material-switch"
                />
              </div>
            }
          </div>
        </AppBar>
      </div>
    )
  }

  /* istanbul ignore next */
}
function mapStateToProps(state) {
  return {
    common: state.common
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(NavVendedor))
